export default __webpack_public_path__ + "static/media/86.d465c800.png";